import * as React from 'react';
import { EditingStyle } from '../../types';

type EditEditingStyleModalState = {
    editingStyleToEdit: EditingStyle | null;
    editDialogOpen: boolean;
    openEditDialog: (editingStyle: EditingStyle) => void;
    closeEditDialog: () => void;
};

export function useEditEditingStyleModal(): EditEditingStyleModalState {
    const [editingStyleToEdit, setEditingStyleToEdit] = React.useState<EditingStyle | null>(null);
    const [editDialogOpen, setEditDialogOpen] = React.useState(false);

    function openEditDialog(editingStyle: EditingStyle) {
        setEditingStyleToEdit(editingStyle);
        setEditDialogOpen(true);
    }

    function closeEditDialog() {
        setEditDialogOpen(false);
    }

    return { editingStyleToEdit, editDialogOpen, openEditDialog, closeEditDialog };
}
